import { ResourceOptions } from 'react-admin';
import { FaComments } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.socialTradingMessageStats;
export const icon = FaComments;
export const options: ResourceOptions = {
  label: 'module.socialTrading.messageStats',
};
